import React from 'react';

import { Container, Title, ExpandIcon } from './styles';

const ServerName: React.FC = () => {
  return (
    <Container>
      <Title> Pawee Space by Dino</Title>

      <ExpandIcon />
    </Container>
  );
};

export default ServerName;
